import CrearActualizar from "./CrearActualizar";
import Listar from "./Listar";

export default { CrearActualizar, Listar };